import React, { useCallback, useEffect } from 'react';
import { Tab, Tabs, styled } from '@mui/material';
import useScreenShareParticipant from '../../hooks/useScreenShareParticipant/useScreenShareParticipant';

const FreeTrialTabsHeader = styled(Tabs)(() => ({}));
const FreeTrialSideTab = styled(Tab)(() => ({
    textTransform: 'none',
    width: '50%',
    fontFamily: 'Fira Sans',
    fontSize: '20px',
    color: '#525252 !important',
    fontWeight: '300',
    '&.Mui-selected': {
        fontWeight: 'bold'
    }
}));

export default function FreeTrialWindowHeader({
    onTabChange
}: {
    onTabChange: (value: number) => void;
}) {
    const [value, setValue] = React.useState(0);
    const handleChange = useCallback(
        (event: any, newValue: number) => {
            setValue(newValue);
            onTabChange(newValue);
        },
        [onTabChange]
    );
    const screenShareParticipant = useScreenShareParticipant();
    useEffect(() => {
        if (screenShareParticipant) {
            setValue(2);
            onTabChange(2);
        } else {
            onTabChange(0);
            setValue(0);
        }

        return () => {
            onTabChange(0);
            setValue(0);
        };
    }, [screenShareParticipant, onTabChange]);
    return (
        <FreeTrialTabsHeader
            scrollButtons="auto"
            value={value}
            variant="scrollable"
            TabIndicatorProps={{ style: { background: '#525252' } }}
            onChange={handleChange}
            aria-label="basic tabs"
            classes={{
                flexContainer: 'media-side-tabs-container'
            }}>
            {screenShareParticipant && <FreeTrialSideTab label="Participants" value={2} />}
            <FreeTrialSideTab label="Call Status" value={0} />
            <FreeTrialSideTab label="Coach Guide" value={1} />
        </FreeTrialTabsHeader>
    );
}
